import { render, staticRenderFns } from "./summarystockinfo.vue?vue&type=template&id=5cdac684"
import script from "./summarystockinfo.vue?vue&type=script&lang=js"
export * from "./summarystockinfo.vue?vue&type=script&lang=js"
import style0 from "./summarystockinfo.vue?vue&type=style&index=0&id=5cdac684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports